import { graphql, useStaticQuery } from 'gatsby';
import { getSpreeProductsBySlug } from 'utils/helpers';
import { ContentfulReview, ProductVariants, Reviews } from 'utils/types';

/**
 * for showing product card data in Popular Tests
 * and More Tests sections on homepage/PDP's
 *  */

const getContentfulProductsBySlug = (
  allContentfulProduct: any,
  productVariants: ProductVariants,
  allReviews: Reviews,
) => {
  const spreeProductsBySlug = getSpreeProductsBySlug(productVariants);
  return allContentfulProduct?.nodes?.reduce(
    (acc: Record<string, any>, node: any) => {
      if (node.category || node.categories) {
        const spreeProduct = spreeProductsBySlug[node.slug];
        if (spreeProduct) {
          acc[node.slug] = {
            slug: node.slug,
            name: spreeProduct.name,
            price: spreeProduct.price,
            boxImage: node.productCardImage,
            cartImage: node.boxImage,
            isNew: node.isNew,
            onSale: node.onSale,
            productId: spreeProduct.productId,
            variantId: spreeProduct.variantId,
            promotionable: spreeProduct.promotionable,
            outOfStock: node.outOfStock,
            reviewData: allReviews?.nodes.find(
              (rev: ContentfulReview) =>
                rev.product_page_id === spreeProduct.productId,
            ),
            checkAvailability: node.checkAvailability,
          };
        }
      }
      return acc;
    },
    {},
  );
};

const useProductBySlug = (productVariants: ProductVariants) => {
  const { allContentfulProduct, allReviews } = useStaticQuery(graphql`
    query {
      allContentfulProduct {
        nodes {
          displayName
          slug
          isNew
          onSale
          category {
            title
          }
          categories {
            title
          }
          boxImage {
            gatsbyImageData(placeholder: BLURRED)
          }
          productCardImage {
            gatsbyImageData(placeholder: BLURRED, width: 1500, quality: 75)
          }
          checkAvailability
          outOfStock
        }
      }
      allReviews {
        nodes {
          product_name
          product_page_id
          average_rating
          native_review_count
          question_count
          rating_histogram
          recommended_ratio
          review_count
          syndicated_review_count
        }
      }
    }
  `);
  const productsBySlug = getContentfulProductsBySlug(
    allContentfulProduct,
    productVariants,
    allReviews,
  );

  return productsBySlug;
};
export default useProductBySlug;
